import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import icons from '../icons';
import { isRTL } from '../config';
import { alertClass } from './styles';
import { capitalize } from '../utils/strings';
import { defaultProps } from '../utils/defaultProps';

var DefaultProps = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  iconSize: 16,
  duration: 200,
  type: 'warning'
});

var Alert =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Alert, _PureComponent);

  var _super = _createSuper2(Alert);

  function Alert(props) {
    var _this;

    _classCallCheck(this, Alert);

    _this = _super.call(this, props);
    _this.element = void 0;
    _this.state = {
      dismiss: 0
    };
    _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_this));
    _this.dismiss = _this.dismiss.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    _this.renderClose = _this.renderClose.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Alert, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.dismiss !== prevProps.dismiss && this.props.dismiss) {
        this.handleClose();
      }
    }
  }, {
    key: "bindRef",
    value: function bindRef(el) {
      this.element = el;
    }
  }, {
    key: "dismiss",
    value: function dismiss() {
      var onClose = this.props.onClose;
      this.setState({
        dismiss: 2
      });

      if (typeof onClose === 'function') {
        onClose();
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var _this2 = this;

      if (this.state.dismiss > 0) return;
      var _this$props = this.props,
          _this$props$duration = _this$props.duration,
          duration = _this$props$duration === void 0 ? DefaultProps.duration : _this$props$duration,
          outAnimation = _this$props.outAnimation,
          onClose = _this$props.onClose; // outer animation

      if (outAnimation) {
        if (typeof onClose === 'function') {
          onClose(duration, this.element.offsetHeight);
        }

        return;
      }

      if (duration > 0) {
        this.setState({
          dismiss: 1
        }, function () {
          setTimeout(_this2.dismiss, duration);
        });
      } else {
        this.dismiss();
      }
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var icon = this.props.icon;
      var _this$props2 = this.props,
          _this$props2$type = _this$props2.type,
          type = _this$props2$type === void 0 ? DefaultProps.type : _this$props2$type,
          _this$props2$iconSize = _this$props2.iconSize,
          iconSize = _this$props2$iconSize === void 0 ? DefaultProps.iconSize : _this$props2$iconSize;

      if (typeof icon === 'boolean' && icon) {
        icon = icons[capitalize(type)];
      }

      if (!icon) return null;
      var style = {
        width: iconSize,
        height: iconSize,
        marginRight: iconSize / 2
      };

      if (isRTL()) {
        style.marginLeft = style.marginRight;
        delete style.marginRight;
      }

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: alertClass('icon'),
          style: style
        }, icon)
      );
    }
  }, {
    key: "renderClose",
    value: function renderClose() {
      var closeItem = this.props.closeItem;
      if (
      /*#__PURE__*/
      React.isValidElement(closeItem)) return (
        /*#__PURE__*/
        React.cloneElement(closeItem, {
          onClick: this.handleClose
        })
      );
      return (
        /*#__PURE__*/
        React.createElement("a", {
          className: alertClass('close'),
          onClick: this.handleClose
        }, closeItem || icons.Close)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var dismiss = this.state.dismiss;
      if (dismiss === 2) return null;
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          type = _this$props3.type,
          onClose = _this$props3.onClose,
          outAnimation = _this$props3.outAnimation,
          hideClose = _this$props3.hideClose;
      var icon = this.renderIcon();
      var style = this.props.style;
      var showClose = onClose && !hideClose;
      var wrapClassName = alertClass('_', type, !outAnimation && dismiss === 1 && 'dismissed', showClose && 'with-close', icon && 'with-icon', isRTL() && 'rtl');
      if (className) wrapClassName += " ".concat(className);
      return (
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindRef,
          className: wrapClassName,
          style: style
        }, showClose && this.renderClose(), icon,
        /*#__PURE__*/
        React.createElement("div", {
          className: alertClass('content')
        }, children))
      );
    }
  }]);

  return Alert;
}(PureComponent);

Alert.defaultProps = DefaultProps;
Alert.displayName = void 0;
Alert.displayName = 'ShineoutAlert';
export default Alert;